module.exports = __webpack_public_path__ + "img/ics_o_mention.351a5cd8.svg";